import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAddresses } from 'app/entities/address/address.reducer';
import { getEntities as getBankAccounts } from 'app/entities/bank-account/bank-account.reducer';
import { getEntities as getContacts } from 'app/entities/contact/contact.reducer';
import { createEntity, getEntity, reset, updateEntity } from './customer-account.reducer';

export const CustomerAccountUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const addresses = useAppSelector(state => state.address.entities);
  const bankAccounts = useAppSelector(state => state.bankAccount.entities);
  const contacts = useAppSelector(state => state.contact.entities);
  const customerAccountEntity = useAppSelector(state => state.customerAccount.entity);
  const loading = useAppSelector(state => state.customerAccount.loading);
  const updating = useAppSelector(state => state.customerAccount.updating);
  const updateSuccess = useAppSelector(state => state.customerAccount.updateSuccess);

  const handleClose = () => {
    navigate('/customer-account');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAddresses({}));
    dispatch(getBankAccounts({}));
    dispatch(getContacts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }

    const entity = {
      ...customerAccountEntity,
      ...values,
      billingAddress: addresses.find(it => it.id.toString() === values.billingAddress?.toString()),
      bankAccount: bankAccounts.find(it => it.id.toString() === values.bankAccount?.toString()),
      contractHolder: contacts.find(it => it.id.toString() === values.contractHolder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...customerAccountEntity,
          billingAddress: customerAccountEntity?.billingAddress?.id,
          bankAccount: customerAccountEntity?.bankAccount?.id,
          contractHolder: customerAccountEntity?.contractHolder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.customerAccount.home.createOrEditLabel"
            data-cy="CustomerAccountCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.customerAccount.home.createOrEditLabel">
              Create or edit a CustomerAccount
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="customer-account-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.customerAccount.isContact')}
                id="customer-account-isContact"
                name="isContact"
                data-cy="isContact"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.customerAccount.collectiveInvoice')}
                id="customer-account-collectiveInvoice"
                name="collectiveInvoice"
                data-cy="collectiveInvoice"
                check
                type="checkbox"
              />
              <ValidatedField
                id="customer-account-billingAddress"
                name="billingAddress"
                data-cy="billingAddress"
                label={translate('crawlerBackendApp.customerAccount.billingAddress')}
                type="select"
              >
                <option value="" key="0" />
                {addresses
                  ? addresses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="customer-account-bankAccount"
                name="bankAccount"
                data-cy="bankAccount"
                label={translate('crawlerBackendApp.customerAccount.bankAccount')}
                type="select"
              >
                <option value="" key="0" />
                {bankAccounts
                  ? bankAccounts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="customer-account-contractHolder"
                name="contractHolder"
                data-cy="contractHolder"
                label={translate('crawlerBackendApp.customerAccount.contractHolder')}
                type="select"
              >
                <option value="" key="0" />
                {contacts
                  ? contacts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/customer-account"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CustomerAccountUpdate;
